<template>
  <div class="camp2path1" v-if="path == 1">

    <div class="path">
        
        <div :class="openedTile !== 0 ? 'step-content open' : 'step-content'">

            <a v-if="openedTile !== 0" class="back-to-list" @click="closeTile()"><span>&lt;</span> Back to the list</a>

            <a v-if="openedTile === 0" class="close" @click="voidPath()"><span>x</span></a>

            <ul v-if="openedTile === 0" :class="('nav step' + step)">
                <li><a class="step1" @click="goto(1)">Setting the Table <span :class="(getProgress(1) + 'progress p'+ progress1)"></span></a></li>
                <li><a class="step2" @click="goto(2)">Governance <span :class="(getProgress(2) + 'progress p'+ progress2)"></span></a></li>
                <li><a class="step3" @click="goto(3)">Vision, Mission & Values <span :class="(getProgress(3) + 'progress p'+ progress3)"></span></a></li>
                <li><a class="step4" @click="goto(4)">Leadership <span :class="(getProgress(4) + 'progress p'+ progress4)"></span></a></li>
                <li><a class="step5" @click="goto(5)">Assets <span :class="(getProgress(5) + 'progress p'+ progress5)"></span></a></li>
            </ul>

            <div v-if="step == 1">
                <h1 v-if="(openedTile === 0)">Setting the Table</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('1.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('1.1')" class="preview" @click="showTile('1.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo94588219.png'" alt="Family Legacy – Cousins & Shareholders">
                            </div>
                            <div class="description">
                                <strong>Family Legacy – Cousins & Shareholders</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('1.1')" class="item-content">
                            <div class="block">
                                <h1>Family Legacy – Cousins & Shareholders</h1>
                                <div class="res-date">Published: May 12, 2014</div>

                                <p>Listen to Tom Darley, Anthony Basile and James Darley discuss the lasting family legacy in their family businesses and how they came about. It is common in a family business, that family values help shape the values that ultimately govern the business. It is these unique values that form the foundation of a lasting legacy for a family business.</p>
                                
                                <iframe src="https://player.vimeo.com/video/94588219?dnt=1&app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous hide"></a>
                                <a class="next" @click="showTile('1.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('1.2')" class="preview" @click="showTile('1.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/camp2-1-1.2.png'" alt="Communication">
                            </div>
                            <div class="description">
                                <strong>Communicating a Message</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('1.2')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/communication1/?c=1" target="_blank" class="play-link">
                                <span>Click to launch the course</span>
                                <img :src="baseurl + 'assets/images/camp2-1-1.2.png'" alt="Communicating a Message" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.1')">Previous</a>
                                <a class="next" @click="showTile('1.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('1.3')" class="preview" @click="showTile('1.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/FamBizGraphic.jpg'" alt="Interfacing Lifecycle Imply Constant Change">
                            </div>
                            <div class="description">
                                <strong>Interfacing Lifecycle Imply Constant Change</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('1.3')" class="item-content">
                            <div class="block">

                                <h1 class="res-title">Interfacing Lifecycle Imply Constant Change</h1>
                                <div class="res-date">Published: Feb 22, 2022</div> 

                                <p>Family Enterprise Advisors (FEAs) are taught the important principle that “interfacing lifecycles imply constant change”.&nbsp; &nbsp;&nbsp;That’s because there are a lot of interfacing aspects affecting the continuity of every family enterprise.</p>

                                <p>Simply stated, by being equipped to anticipate and welcome <em>constant change</em> as a part of the family enterprise lifecycle, families will be better able to build the governance systems needed to prosper through all of the stages that lie ahead.</p>

                                <p>Not every business owner will want to invest the time or money to work through all of these complexities over the changing interfacing lifecycles.&nbsp;And that’s perfectly all right, because it’s not for everyone.&nbsp; And for those who don’t want to, the family business can be liquidated along the path, or converted to a Family Investment Office or Family Office.</p>

                                <p>Everything has a lifecycle.&nbsp; Think about it, 50 years ago, they said technology doubled every 30 years.&nbsp; We know it’s much faster today…so let’s face it, things change, and really quickly!&nbsp;Not only do products change, but so, too, do individuals and entire industries change.&nbsp;</p>

                                <p>In the FEA course, we are taught there are in fact 5 distinct interfacing axes that will affect a family business over time, being 1) Family, 2) Organization (i.e. the business), 3) Individual, 4) Industry, and 5) Ownership.&nbsp;Manfred F.R. Kets De Vries, developed a very interesting chart to reflect the lifecycle over the many changing interfaces of a family business.</p>

                                <div class="wp-block-image"><figure class="aligncenter size-full is-resized"><img :src="baseurl + 'assets/images/FamBizGraphic.jpg'" alt="" ><figcaption><small>Source: Kets de Vries et al,&nbsp;Family business on the couch. A psychological perspective.<br />(Chichester: John Wiley &amp; Sons, 2007).</small></figcaption></figure></div>

                                <p>Along the Family axis, members start off young, and then age, go through parenting, grand parenting and retirement.&nbsp; Along this path, too, change can arise as new members are born, marry or divorce, and ultimately pass away.</p>

                                <p>The Organization axis has a natural lifecycle, consisting of start-up, growth, and either decline or regeneration.&nbsp; &nbsp;Ichak Adizes, one of the leading experts on corporate lifecycles, identifies 10 stages: courtship, infancy, go-go, adolescence, prime, the fall, aristocracy, recrimination, bureaucracy, and death.&nbsp; His teachings are a good reference for any family wishing to plan ahead.</p>

                                <p>The Individual axis moves along the maturity continuum, from youngster to adolescent, to mid-life and finally the mature adult, and is also affected by health and mortality.&nbsp;</p>

                                <p>The Industry lifecycle axis has stages progressing from 1) start-up, to 2) growth, to 3) maturity, and then to either 4) decline (and death) or 5) expansion and further growth.&nbsp; Think of Blockbuster, Tower records, and Kodak to name a few of the industry player who faced an industry decline.&nbsp;&nbsp;</p>

                                <p>The Ownership lifecycle axis moves from the simpler stage of single owner or family partners, to sibling partners, to cousin consortium and ultimately to a family syndicate with wider ownership and more challenging ownership decisions.</p>

                                <p>One must congratulate those family enterprises that have successfully navigated all of the lifecycle changes on the 5 axes over the lifecycle continuity spectrum.&nbsp;</p>

                                <p>With good advice from experts in family enterprise planning like FEAs, and a multi-disciplinary team of skilled experts to lend a hand, good governance systems can be built to deal with the changes that are inevitable. FEAs are able to help enterprise families anticipate the lifecycle changes, and understand the governance tools needed in all 3 Circles, to make the needed decisions by the family, for the family.</p>

                                <p>It’s not easy to have a fam  w ily enterprise survive over many generations, but then again, if it were easy, everyone would be a Henry Ford.&nbsp; So, congratulations to Henry and his family successors, who enabled the everyman to own a car, and helped propel the world of robotic automation.&nbsp;</p>

                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.2')">Previous</a>
                                <a class="next" @click="showTile('1.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('1.4')" class="preview" @click="showTile('1.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/roadmap-for-KPMG.svg'" alt="Preparing the Next Generation: A Family Business Roadmap">
                            </div>
                            <div class="description">
                                <strong>Preparing the Next Generation: A Family Business Roadmap</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('1.4')" class="item-content">
                            
                            <div class="block">
                                
                                <h1 class="res-title">Preparing the Next Generation: A Family Business Roadmap</h1>
                                <div class="res-author">Family Enterprise Foundation</div>
                                <div class="res-date">Published: Jun 15, 2023</div>  
                                
                                <p>The riskiest time for a family business occurs during changes in ownership and leadership. With the great wealth transfer of family businesses now underway, next generation transitions will ramp up quickly. So much is at stake for the business families themselves, their local communities that rely on them and even our national economy. It’s vital that these transitions are successful.</p>

                                <p>Research that identifies a clear path to a smooth transition is valuable to business families, advisors to those families and the whole family enterprise ecosystem. That is what this research addresses, and it provides key insights on:</p>

                                <ul><li>What are the keys to maintaining family harmony and business longevity?</li><li>What has worked well in their succession and transition planning journeys?</li><li>What are the roadblocks and pitfalls to avoid along the way?</li></ul>

                                <div class="cols">
                                    <div class="col">
                                        <figure class="aligncenter size-full"><a href="https://familyenterprise.ca/wp-content/uploads/2023/06/Preparing-the-Next-Generation-June-2023.pdf" target="_blank" rel="noreferrer noopener"><img width="500" height="647" :src="baseurl + 'assets/images/NextGen-Report-Cover-Thumbnail-border.jpg'" alt="" class="wp-image-1109682"></a></figure>
                                        <p style="text-align: center;"><a href="https://familyenterprise.ca/wp-content/uploads/2023/06/Preparing-the-Next-Generation-June-2023.pdf" target="_blank" rel="noreferrer noopener">Read the report</a></p>
                                    </div>
                                    <div class="col">
                                        
                                        <figure class="aligncenter size-full"><a href="https://familyenterprise.ca/resource/preparing-the-next-generation-podcast/" target="_blank" rel="noreferrer noopener"><img loading="lazy" width="600" height="328" :src="baseurl + 'assets/images/LetsTalkFamilyEnterprise_Website-48-border.png'" alt="" class="wp-image-1109677"></a></figure>
                                        <p style="text-align: center;"><a href="https://familyenterprise.ca/resource/preparing-the-next-generation-podcast/" target="_blank" rel="noreferrer noopener">Listen to the podcast</a></p>
                                    </div>
                                </div>
                                
        
                                <p>Our Foundation’s research provides the most comprehensive picture of transition intentions in Canadian business families to date. The third part of this national research, based on interviews with the next generation, is summarized in the latest Family Enterprise Foundation report,&nbsp;<em>Preparing the Next Generation: A Family Business Roadmap</em>, available in English and French.</p>

                                <h2>Why research this?</h2>

                                <p>This new research builds on two earlier quantitative studies by Family Enterprise Foundation, <a href="https://familyenterprise.ca/resource/ready-willing-and-interested-or-not-report/" target="_blank" rel="noreferrer noopener">Ready, Willing and Interested — or NOT?</a> (2021) and <a href="https://familyenterprise.ca/resource/research-on-canadian-family-business-transition-intentions-part-one-two/" target="_blank" rel="noreferrer noopener">Who are the Guardians of Family Legacy?</a> (2022).</p>

                                <p>When family business leaders consider their succession journey and the future of their business, often the focus is exclusively on finances and tangible assets. However, our previous research revealed that <strong>next generation preparedness is actually the biggest concern when considering intergenerational succession.</strong> So, while financial considerations should always remain a part of the larger picture, the future of a family’s legacy lies in its human capital and effectively preparing the next generation.</p>

                                <p><a href="https://familyenterprise.ca/wp-content/uploads/2023/06/Preparing-the-Next-Generation-June-2023.pdf" target="_blank" rel="noreferrer noopener">Read the report</a> </p>

                                <h2 class="has-text-align-center">The Family Business Roadmap</h2>

                                <figure class="wp-block-image size-large is-resized is-style-default"><img :src="baseurl + 'assets/images/roadmap-for-KPMG.svg'" alt="" class="wp-image-1109684" style="width: 100%;"></figure>

                                <p>In this research, in-depth interviews with next generation family business members identified<strong> five practical strategies in a roadmap</strong> to help both generations prepare for the transition process:</p>

                                <ol><li><strong>Foster early involvement and emotional connectedness:</strong> Nurture strong emotional bonds to the family business through early exposure and involvement, which helps to measure and to build interest.</li><li><strong>Train and prepare:</strong> Create a comprehensive training and preparation program for the next generation. The program should feature both formal and informal learning structures and may involve experience gained outside the business.</li><li><strong>Encourage mentorship and peer interactions:</strong> Encourage peer interactions and mentorship to provide the next generation with a robust network to learn from and lean on throughout their career. Surprisingly, nearly all study participants received guidance from a mentor.</li><li><strong>Find the right role:</strong> Rotational programs are an effective way to help next gens find the right role in the business. However, most respondents believe the next generation should not be forced or expected to play a role in the business. They should only be involved if they are fully aware of the responsibilities of ownership and are passionate about the opportunity.</li><li><strong>Involve trusted advisors:</strong> External advisors are cited by participants as among the most desired and beneficial supports for family enterprises. Involve advisors who are specifically trained to work with business families to help maintain harmony by opening communication and improving transparency.</li></ol>


                                <h2>How to leverage this research</h2>

                                <p>Family business leaders and Family Enterprise Advisors (FEAs) can implement the learnings and the practical roadmap from this research into their own family enterprises and practices by reading the full report: <a href="https://familyenterprise.ca/wp-content/uploads/2023/06/Preparing-the-Next-Generation-June-2023.pdf" target="_blank" rel="noreferrer noopener">Read the report</a>.</p>


                                <h2>Thank you for your support</h2>

                                <p>We would like to thank <a href="https://kpmg.com/ca/en/home/services/enterprise/family-office.html" target="_blank" rel="noreferrer noopener">KPMG Family Office</a> and the <a href="https://jabff.com/" target="_blank" rel="noreferrer noopener">James A. Burton &amp; Family Foundation</a> for their generous support of this research and their ongoing support of family enterprise in Canada.</p>

                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.3')">Previous</a>
                                <a class="next" @click="showTile('1.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('1.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('1.5')" class="preview" @click="showTile('1.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/compass1-6.png'" alt="Balancing Family and Business">
                            </div>
                            <div class="description">
                                <strong>Balancing Family and Business</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('1.5')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/compass/?c=6" target="_blank" class="play-link">
                                <span>Click to complete Compass Unit 1</span>
                                <img :src="baseurl + 'assets/images/compass1-6.png'" alt="Balancing Family and Business" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.4')">Previous</a>
                                <a class="next" @click="showTile('1.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('1.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('1.6')" class="preview" @click="showTile('1.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/purpose.jpg'" alt="Cousin Consortium">
                            </div>
                            <div class="description">
                                <strong>Cousin Consortium</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('1.6')" class="item-content">
                            <iframe :src="baseurl + 'assets/pdf/family/MulliezFamilyVisioningProcess-H.pdf'" class="pdf"></iframe>
                            
                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/MulliezFamilyVisioningProcess-H.pdf'" target="_blank">Mulliez Family Visioning Process</a></li>
                                </ul>
                            </div>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('2.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>









            <div v-if="step == 2">
                <h1 v-if="openedTile === 0">Clarifying the Goals and Priorities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('2.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('2.1')" class="preview" @click="showTile('2.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo94587950.png'" alt="Succession Planning – Cousins & Shareholders">
                            </div>
                            <div class="description">
                                <strong>Succession Planning – Cousins & Shareholders</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('2.1')" class="item-content">
                            <div class="block">
                                <h1>Succession Planning – Cousins & Shareholders</h1>
                                <div class="res-date">Published: May 12, 2014</div>
    
                                <p>Listen to Paul Darley and David Schoedinger explain their experience with succession planning. It is always important to prepare an ongoing succession plan before an unforeseen event takes place. In a family business, it may be helpful to include advisors, and other impartial professionals when making important decisions, to provide the family with an objective perspective.</p>

                                <iframe src="https://player.vimeo.com/video/94587950?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>  

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('1.6')">Previous</a>
                                <a class="next" @click="showTile('2.2')">Next</a>
                            </div>
  
                        </div>
                    </li>
                    <li :class="statusClass('2.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('2.2')" class="preview" @click="showTile('2.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Effective Governance Systems">
                            </div>
                            <div class="description">
                                <strong>Effective Governance Systems</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.2')" class="item-content">
                            
                            <div class="block">
                                <h1 class="res-title">Effective Governance Systems</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>

                                <p>Effective governance systems form the very root of our ethical behavior as human beings and are what primarily distinguish us from all other living things.&nbsp; The 10 Commandments are one of the first articulated governance systems laid out for mankind to follow as a collective group, to work together effectively for the benefit of everyone.&nbsp;Without such governance system, there would be chaos.</p>

                                <p>Similarly, governance systems are needed in all 3 circles of the 3-Circle model applicable for a successful family enterprise continuity plan, governing the Family, the Business and the Ownership. The most important goals of governance include:</p>

                                <ul><li><strong>Cohesion</strong> – to work together for the welfare of the group.</li><li><strong>Learning and development</strong> – to help each other learn and improve.</li><li><strong>Skills development</strong> – to hone the expertise that depends on experience and mentorship.</li><li><strong>Repair and strengthen relationships</strong> – to enable human relational healing.</li><li><strong>Plan with the family for the family</strong> – to enable the family to work as a united team.</li><li><strong>Give voice to all members</strong> – so everyone feels they are contributing in some fashion and have a sense of belonging.</li><li><strong>Differentiate 3 circles</strong> – to recognize that different governance techniques are uniquely needed in each circle.</li><li><strong>Build potential for NextGen owners </strong>– to groom and entice the next generation to receive the baton and run with it as the speed needed to win the family enterprise marathon.</li></ul>

                                <p>There are several proven governance systems, which can be considered, including:</p>

                                <ul><li><strong>Family Circle</strong> – Family Constitution (with clear vision, mission, and value statements), Family Meetings, Family Council, Family Office, Family Foundation</li><li><strong>Business Circle </strong>– Strategic Business Plan, Independent Board of Directors, Board Meetings, Formal Job Descriptions, Performance Appraisals</li><li><strong>Ownership Circle</strong> – Shareholders Agreement, Shareholder Assembly, Owner’s Council, Shareholder Meetings</li></ul>

                                <p>Good governance provides for all parties the clear definition of the goals and expectations, and acts like a road map to provide the checks and balances as to where you are at present against where you need to be.&nbsp; It requires regular periodic assessment and evaluation to ensure the right resources are in place, making the right decisions.</p>

                                <p>Good governance is intended to lead to the most timely and effective decisions, but they are not always easy ones.&nbsp; You may have read that the Weston family, an incredible example of a successful multi-generation family enterprise, decided to divest their ownership in the famous Selfridges department store chain in the UK. It was a very prestigious asset for their family, without doubt, located in one of the most desirable locations in London.&nbsp; This decision must not have been easy at all, and is a strong example of the role of good governance in dynamic decision-making.&nbsp;In discussing the sale, Allanah Weston graciously commented: “I am proud to pass the baton to the new owners who are family businesses that take a long term view.&nbsp;I know they will fully embrace that vision and continue to empower our incredible team to take the Group from strength to strength”.&nbsp; Essentially, Ms. Weston made the brave admission that someone else may be better suited to taking the enterprise to the next stage in its continuity lifecycle.</p>

                                <p>Effective continuity planning is not easy at all.&nbsp; Like Bob Dylan sings…”it’s a hard, it’s a hard”.&nbsp; But investing the time and effort to install good governance will significantly enhance the likely outcome of success, and must form the center of any long-term family enterprise continuity plan.&nbsp;</p>

                                <p><strong><strong><strong>Congratulations! Continue as a Family Enterprise</strong></strong></strong></p>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.1')">Previous</a>
                                <a class="next" @click="showTile('2.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('2.3')" class="preview" @click="showTile('2.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/tut1.png'" alt="The Role of a Family Constitution">
                            </div>
                            <div class="description">
                                <strong>The Role of a Family Constitution</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.3')" class="item-content">
                            <h1>The Role of a Family Constitution</h1>
                            <p>FEF Learning Paths present family business members with a unique learning experience. In the three step paths, you will:</p>
                            <ol>
                                <li>Hear from an expert or family member on the chosen topic</li>
                                <li>Reflect and answer a number of thought-provoking questions on the chosen topic</li>
                                <li>Use the given templates to begin building questions, analyses and a game plan for you and your family on the chosen topic.</li>
                            </ol>

                            <p>These multimedia, integrated capsules are great for individual learning, for use with a family advisor as well as sharing amongst family members. Enjoy this interactive learning!</p>

                            <a href="https://familyenterprise.ca/resources/tut1/#introduction" target="_blank" class="play-link">
                                <span>Click to complete the assessment</span>
                                <img :src="baseurl + 'assets/images/tut1.png'" alt="The Role of a Family Constitution" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.2')">Previous</a>
                                <a class="next" @click="showTile('2.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('2.4')" class="preview" @click="showTile('2.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo62108551.jpg'" alt="What is a Family Council?">
                            </div>
                            <div class="description">
                                <strong>The Giving Governance of Multi-Generational Families</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.4')" class="item-content">
                            
                            <div class="block">
                                <h1>The Giving Governance of Multi-Generational Families</h1>
                                <div class="res-author">Sharilyn Hale, Watermark Philanthropic Counsel</div>
                                <div class="res-date">Published: Dec 11, 2020</div>
                                
                                <p>Families are important drivers of philanthropy. Family enterprises alone generate tremendous wealth, accounting for roughly 60% of Canada’s GDP. This article touches on how generous families in Canada organize to make philanthropic decisions.</p>

                                <iframe src="https://familyenterprise.ca/wp-content/uploads/2020/12/WPC-Governance-Model.pdf" class="pdf"></iframe>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('2.3')">Previous</a>
                                    <a class="next" @click="showTile('2.5')">Next</a>
                                </div>

                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('2.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('2.5')" class="preview" @click="showTile('2.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo62084509.png'" alt="Managing Both the Family and the Business at the Same Time">
                            </div>
                            <div class="description">
                                <strong>Managing Both the Family and the Business at the Same Time</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.5')" class="item-content">
                            
                            <h1>Managing Both the Family and the Business at the Same Time</h1>
                            <div class="res-author">Philippe de Gaspé Beaubien</div>
                            <div class="res-date">Published: Mar 17, 2012</div>

                            <p>Listen to BFF Co-Chair Philippe de Gaspé Beaubien describe how he raised his awareness of family business dynamics and the various risks affecting both the family and the business. When developing a business, it is essential to consider its effects on the family as well as how the family fits into the larger picture. In a family business, it is important to start succession planning early, as well as continually integrate the rising generation.</p>

                            <iframe src="https://player.vimeo.com/video/62084509?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.4')">Previous</a>
                                <a class="next" @click="showTile('2.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('2.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('2.6')" class="preview" @click="showTile('2.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/camp2-1-1.2.png'" alt="Communication & Conflict Management for Business Families">
                            </div>
                            <div class="description">
                                <strong>Communication & Conflict Management. </strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.6')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/communication2/?c=1" target="_blank" class="play-link">
                                <span>Click to launch the course</span>
                                <img :src="baseurl + 'assets/images/camp2-1-1.2.png'" alt="Communication & Conflict Management for Business Families" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('3.1')">Next</a>
                            </div>

                        </div>
                        
                    </li>
                </ul>
            </div>




            <div v-if="step == 3">
                <h1 v-if="openedTile === 0">Reviewing (or Defining) Familiy Strategy</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('3.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('3.1')" class="preview" @click="showTile('3.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo167326717.png'" alt="Our Family Values – A Shared Intention">
                            </div>
                            <div class="description">
                                <strong>Our Family Values – A Shared Intention</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('3.1')" class="item-content">
                            <div class="block">
                                <h1>Our Family Values – A Shared Intention</h1>
                                <div class="res-date">Published: Jun 9, 2016</div> 

                                <p>Listen to Patricia Saputo talk about using values to guide decision-making processes.</p>

                                <iframe src="https://player.vimeo.com/video/167326717?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('2.6')">Previous</a>
                                <a class="next" @click="showTile('3.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('3.2')" class="preview" @click="showTile('3.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What are Paradoxes and Why you Need to be Aware">
                            </div>
                            <div class="description">
                                <strong>What are Paradoxes and Why you Need to be Aware</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('3.2')" class="item-content">
                            
                            <div class="block">

                                <h1>What are Paradoxes and Why you Need to be Aware</h1>

                                <p>You have decided that you are prepared to hire, reward, and retain the best people to build your Family Office, and this will likely be dominated by non-family members.&nbsp; Do be mindful that you face paradoxes that you may not be aware of. A paradox is a statement that is seemingly contradictory or opposed to common sense and yet is perhaps true.</p>

                                <p>As a family enterprise, you are faced with many paradoxes, two perceived contradictory truths.&nbsp; These are two values that appear to be mutually exclusive, but can be in fact, mutually supportive.&nbsp; There’s no right or wrong.&nbsp; And where you see yourself today may be different than where you see yourself tomorrow keeping in account the ever-changing life cycle.</p>
    
                                <p>You must manage both and not think it is ‘either/or’. Paradoxes may come across as contradictory and it is a huge challenge to see and re-frame the knowledge that an individual is part of the collective. The ultimate paradox for a family enterprise is the dance between the “I” and the “WE”. A family often trades the “self” for “togetherness” and as a system the dance between I and We never gets resolved.</p>
    
                                <p>Families have a mindset that there is something to be fixed, that something is broken. They are not broken.&nbsp; Paradoxes exist in all family enterprises. When faced with a paradox the best action forward is to flourish in the paradox: change the mindset to “Both…And” instead of “either.. or”.</p>
    
                                <p>Some examples of paradoxes family enterprise are faced with are:</p>

                                <ul><li><strong>Tradition vs Innovation</strong>: do you stick with the way things have always been done, keep to the traditions that have led to the success to date or do you innovate and bring in new ways for potential greater growth and innovation?&nbsp; Traditions and what’s worked well is best to be recorded and remembered, pairing this up with innovation for continual growth is very advantageous.</li><li><strong>Harvest vs Invest: </strong>do you begin to sell off branches of the business, so the growing family has funds to accumulate their own assets, or do you continue to invest and grow the business?&nbsp;Both, and…</li><li><strong>Individual vs Family</strong>: do you focus on what’s best for “Me” the individual or the “We” the family?&nbsp; Focusing on the individual human capital of the family is just as important as moving forward with what is best for the family as a whole. Speaking about where the differences are is a great place to start to achieve Both, and…</li><li><strong>Family vs Business: </strong>do you put the family first or the business first?&nbsp; While being occupied with the day-to-day operations of your business, you realize you’re no longer paying enough attention to pursuing your vision for the family. The key to dealing with such a paradox is to create a healthy balance. Make sure all that you are doing in the business is aligned with and contributes to your family purpose. There is a time the family is there for the business and another moment the business is there for the family.&nbsp; It is not either, or…</li><li><strong>Growth vs Dividends</strong>: do you reinvest all the growth to keep growing or is it time to payout some dividends. Growing the business today gives better opportunity for greater dividends tomorrow. And a dividend today may help your daughter who just got married start fresh now so she can dedicate more time tomorrow to further grow the company.&nbsp; Again, taking the mindset of “both, and..” allows for better management of the opposing values.</li><li><strong>Loyalty vs Autonomy:</strong> Similar to the values of Individual and Family there is great power in thinking We before Me. At the same time allowing your children the growth in being autonomous brings great value too.&nbsp; There is great strength when an individual finds their own fulfillment and then brings that back to the family. And when there is loyalty to the family believing you are part of a greater whole and all you can do benefits this whole.&nbsp; Both, And..</li><li>Self vs Togetherness: I like the way one individual called this paradox “living together AND alone”.&nbsp; It’s not easy, but important. You can certainly appreciate support from your loved ones for both your grief and your victories, but the internal journey is yours alone. Instead of looking for approval from others you are together with, learn respect for differences and being your true self.&nbsp;</li></ul>
    
                                <p>Assuming power over others may sometimes be required to protect them, note in doing so you diminish their right to autonomy.&nbsp; This may be resolved by re-framing the problem to reveal a false contradiction. A skilled FEA is aware of these paradoxes in family enterprises and can help a family re-frame and see the value of “both,… and.” Paradox is normal in family enterprises. When you allocate time looking for dual solutions and have a common family mission mindset with a team spirit you will achieve</p>
    
                                <p>In hiring, rewarding, and retaining the best people, the family should not be forgotten or left in the side lines.&nbsp; These paradoxes come into play and can be the cause for conflict if not addressed.&nbsp;Hiring the right people who are aware and able to open the conversation with the family will lead to a more harmonious unit and add to the longevity of your family enterprise.</p>
    
                                <p><strong><strong><strong>Congratulations! Continue as a Family Enterprise</strong></strong></strong></p>
    
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.1')">Previous</a>
                                <a class="next" @click="showTile('3.3')">Next</a>
                            </div>


                        </div>
                    </li>
                    <li :class="statusClass('3.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('3.3')" class="preview" @click="showTile('3.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Social Purpose in Family Enterprise">
                            </div>
                            <div class="description">
                                <strong>Social Purpose in Family Enterprise</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('3.3')" class="item-content">
                            
                            <h1>Social Purpose in Family Enterprise</h1>
                            <div class="res-date">Published: Mar 1, 2021</div> 

                            <p>Does your family business have a social purpose? A social purpose business is an enterprise that supports creating a better world. It is an engine for good, creating societal benefits by the very act of conducting business. Businesses around the world are redefining their role in society to foster business and societal success. They are adopting a “social purpose” to navigate turbulent times. Want to learn more about integrating a social purpose into your business? Watch the video below!
                            </p>

                            <iframe src="https://player.vimeo.com/video/518290172?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            
                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a :href="baseurl + 'assets/pdf/family/Slidedeck-Social-Purpose-Presentation-FEX.pdf'" target="_blank">Download the slides</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.2')">Previous</a>
                                <a class="next" @click="showTile('3.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('3.4')" class="preview" @click="showTile('3.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Have You Shared Your Vision with The Family?">
                            </div>
                            <div class="description">
                                <strong>Have You Shared Your Vision with The Family?</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('3.4')" class="item-content">
                            <div class="block">
                                <h1>Have You Shared Your Vision with The Family?</h1>
                                <div class="res-date">Published: Feb 21, 2021</div> 

    
                                <p>You have determined after considerable reflection that you are not a family enterprise, and that is ok. &nbsp;To continue as a family enterprise your family circle needs to be seen as part of the system. And this is no easy task. The following article gives insight on what it is to include the family and going down the road to set up family governance.&nbsp; One way or another sharing your vision forward with your family is an option to consider.</p>
                                                            
                                <p>Too often a business family does not put in the time and effort to share the vision with its family members.&nbsp; It’s the lack of this effort that leads many families to not hire an FEA to go through a process.&nbsp;If you want to reconsider this position here is an outlook of some of the things you would consider.</p>
                                
                                <p>A critical requirement for any healthy continuity plan is openness and transparency.&nbsp;Planning with the family, rather than for the family, is essential to achieve a successful and harmonious outcome.</p>
                                
                                <p>It is only by involving the people most interested in the successful outcome of your succession that you will be able to get the “familiness advantage” that is possible in a family enterprise transition.</p>
                                
                                <p>So what tools are available to help a family enterprise build the family governance foundation needed for a successful continuity plan?</p>
                                
                                <p>The main tools used by successful enterprise families for building family governance are:</p>
                                
                                <ul type="1"><li>The Family Constitution,</li><li>The Family Council</li><li>Family Assemblies </li><li>Family Meetings</li></ul>
                                
                                <p>This article will articulate the Family Constitution and Family Council.&nbsp; The other topics will be covered in later articles in this decision tree.</p>
                                                    
                                <p><strong><u>The Family Constitution</u></strong></p>
                                
                                <p>The Family Constitution is a very important document for every family enterprise to create for the benefit of current and future generations to define how it will govern itself.</p>
                                
                                <p>It is a formal written agreement, developed by the family for the family, articulating a number of very important elements, which may include:</p>
                                
                                <ul><li>The family mission statement (reflecting the family enterprise heritage, culture, goals, etc.)</li><li>Formal by-laws, including voting procedures, and the election of the Family Council</li><li>The family values (e.g. harmony, business growth, reinvestment vs distribution, wealth creation, etc.)</li><li>Family policies for titles, compensation, employment &amp; performance reviews, marriage contracts, retirement, share ownership, life insurance, dividends, etc.</li><li>Policies for Board Membership, including term &amp; rotation, successor criteria, non-family component, election of chair, etc.</li><li>Policies for recruiting senior management leadership, and the role of family members versus merited recruitment from outside the family using professional recruiters</li><li>Code of conduct for how members will deal with one another</li><li>Philanthropic goals (how important is philanthropy)</li><li>Goals and frequency of family meetings</li><li>Mechanisms for dispute resolution</li><li>Confidentiality considerations.</li></ul>
                                
                                <p>There are some wonderful articles and templates available online as reference, for any family to use to scope out a family constitution.&nbsp; A few examples include:</p>
                                
                                <ul><li><a href="https://advisor.morganstanley.com/michelle.ward/documents/field/w/wa/ward-sofia-michelle/Family_Constitution_and_Family_By_Laws.pdf" target="_blank" rel="noreferrer noopener">Family Constitution and Family By-Laws</a></li><li><a href="https://www.bbh.com/us/en/insights/private-banking-insights/we-the-family-the-benefits-of-creating-a-family-constitution.html" target="_blank" rel="noreferrer noopener">We the Family: The Benefits of Creating a Family Constitution</a></li></ul>
                                
                                <p>A family can delegate the duty of developing the family constitution draft to the next generation family members, who can work together as a small team to research, craft and present the draft to their elders.&nbsp; The act of working together in the design of the constitution can ensure that the next generation has the commitment to work together to execute on the outcome.</p>
                                
                                <p>It is customary for the family’s specialist estate lawyer to help the family in formalizing and executing the final family constitution, which can then be inherited by future generations as a roadmap.</p>
                                
                                <p><strong><u>The Family Council</u></strong></p>
                                
                                <p>The power of compounding does not just affect investing.&nbsp; When I married my wife, we were a family of two.&nbsp; We then had 3 daughters and became 5.&nbsp; Our daughters then married, and we became 8. They had 4 children, making us 12, with more grandchildren still to come.&nbsp;And now we are 3 generations.&nbsp;The family are of different ages and stages of life. And they all have an interest in the successful outcome of our family unit.</p>
                               
                                <p>The Family Council is a very useful governance tool for growing families, of several generations, to have an organized governance method to elect competent representation and define and exercise voting rights.&nbsp;</p>
                                
                                <p>In a healthy growing family enterprise, the family will meet (at a family meeting or family assembly), and elect the most competent persons to comprise the Family Council to represent the family on the Board, and the family members in the family governance oversight.&nbsp;</p>
                                
                                <p>Family Councils can be particularly useful for recommending policies and initiatives, as well as tackling the succession challenges that arise.&nbsp;Family Councils report to the family members, and have formal obligations for timely disclosure of all decisions taken.&nbsp;Competence and trust are keys to a successful family council.</p>
                                
                                <p>There are tremendous benefits for a family enterprise to develop a Family Constitution and Family Council.&nbsp; Speak to a Family Enterprise Advisor, who can assist you in mapping out the steps to implement these tools with your family.&nbsp; These tools are best implemented by the family, for the family.</p>
                                
                                <p>If this is a road you don’t foresee you and your family take together than making the choice to not be a family enterprise is the best choice for your family.&nbsp; One way or other, do include them in this decision and share your vision and perspective.&nbsp;</p>
                            
                                <p><strong>Decision Tree Question: No FEA Process</strong>. We suggest you relook at your estate plan and all its elements.</p>
                                

                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.3')">Previous</a>
                                <a class="next" @click="showTile('3.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    
                    <li :class="statusClass('3.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('3.5')" class="preview" @click="showTile('3.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo62342096.png'" alt="Identifying and Developing Leaders">
                            </div>
                            <div class="description">
                                <strong>Identifying and Developing Leaders</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('3.5')" class="item-content">
                            <h1>Identifying and Developing Leaders</h1>
                            <div class="res-author">Kathryn McCarthy</div>
                            <div class="res-date">Published: Jan 31, 2012</div> 

                            <p>Listen to Kathryn McCarthy, a Family Business Advisor and Family Office Expert explain the importance of recognizing different leadership roles and leadership needs in the family business system, accepting the fact that not all family members have the same leadership capabilities, and committing to investing time and money in the development of leaders for the benefit of all members of the system.
                            </p>

                            <iframe src="https://player.vimeo.com/video/62342096?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.4')">Previous</a>
                                <a class="next" @click="showTile('3.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('3.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('3.6')" class="preview" @click="showTile('3.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Theory of Change – Values and Vision">
                            </div>
                            <div class="description">
                                <strong>Theory of Change – Values and Vision</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('3.6')" class="item-content">
                            <h1>Theory of Change – Values and Vision</h1>

                            <iframe :src="baseurl + 'assets/pdf/family/TheoryofChangeValuesandVision-AB.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/TheoryofChangeValuesandVision-AB.pdf'" target="_blank">Process Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('4.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>



            <div v-if="step == 4">
                <h1 v-if="openedTile === 0">Planning the Transition of Responsibilities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('4.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('4.1')" class="preview" @click="showTile('4.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo94587950.png'" alt="Complexities of Communication – Cousins & Shareholders">
                            </div>
                            <div class="description">
                                <strong>Complexities of Communication – Cousins & Shareholders</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('4.1')" class="item-content">
                            <div class="block">
                                
                                <h1>Complexities of Communication – Cousins & Shareholders</h1>
                                <div class="res-author">Joseph Astrachan, Stephen Woodman, Paul Darley</div>
                                <div class="res-date">Published: May 5, 2014</div>
                                
                                <p>Listen to Joseph Astrachan, Stephen Woodman and Paul Darley discuss the importance in communicating within a family business. Frequent communication between all members in a family business, particularly stakeholders, is essential in the avoidance and resolution of conflict. When communicating, it is equally important to discuss both conflicts as well as successes of the business.</p>

                                <iframe src="https://player.vimeo.com/video/94018434?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="previousStep(); showTile('3.6')">Previous</a>
                                    <a class="next" @click="showTile('4.2')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('4.2')" class="preview" @click="showTile('4.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Risk of Nepotism?">
                            </div>
                            <div class="description">
                                <strong>Risk of Nepotism?</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('4.2')" class="item-content">
                            
                            <div class="block">

                                <h1>Risk of Nepotism?</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>
                    
                                <p>I just watched the show Succession.&nbsp;Episode 2 is a lot of fun to watch. The 80 year old billionaire media patriarch has a brain seizure, becomes unconscious and is hospitalized in the ICU.&nbsp; Almost immediately, right in the hospital, every one of his shallow and inept sons lobby themselves to take over as the new CEO.&nbsp;To get board approval, two of the sons team up as CEO and COO.&nbsp;But that does not inspire any shareholder confidence, and the share price plummets, causing a breach of loan covenants. &nbsp;&nbsp;&nbsp;</p>
    
                                <p>Fiction is pretty close to fact in this instance.&nbsp;In the absence of a well thought out succession plan, where a deserving successor has been selected and groomed to take over as the future leader, there can be a huge gap created when an incumbent leader has a sudden and material health catastrophe or, worse, passes away suddenly.</p>
    
                                <p>In the absence of a succession plan, nepotism takes over.&nbsp;Those with the loudest voice, or most egotistic or aggressive personalities, can force their way into the executive suite.&nbsp;This can lead to catastrophic results where non-family and family staff leave, customers and suppliers start to question the future of their relationships, and bankers and investors start to worry about the safety of their capital.</p>
    
                                <p>Often, families place family members in senior management roles simply because they feel they have a right, notwithstanding a lack of merit or needed skillset.&nbsp;&nbsp; Merit includes training and education, work experience and ethic, vision, and strong collegiate leadership skills.&nbsp;</p>
    
                                <p>A family enterprise continuity plan requires the right person in the right job.&nbsp; And it requires timely and effective performance appraisals to provide constructive feedback, and compensation based on goal attainment.&nbsp; It should not reward mediocrity, or permit substandard performance to carry on without remediation or a change of staff member.&nbsp;</p>
    
                                <p>Nepotism can seriously challenge the continuity of a healthy family enterprise, and alienate all of the parties with an interest in the best outcome.</p>
    
                                <p>A family enterprise needs a leader with the skills training, and leadership qualities to not only motivate the staff, but also bring the necessary vision, values, and strategy for leading the way forward. &nbsp;And part of the job description of any current leader should include the development of a continuity plan for the replacement of the most senior members of the management team, as this can take a lot of time and advance thought.</p>
    
                                <p>Nepotism can kill a family enterprise, or at the very least set it back in the eyes of its most interested parties, including family members, management, suppliers, bankers, and other shareholders. Of late, we have seen a number of board battles caused by nepotism at the expense of independent board decision making.&nbsp; In the absence of good governance, there are no checks and balances to assure the best decisions. &nbsp;&nbsp;Sometimes families resort to the courts to force a change when mired in nepotism. Invariably it reflects poorly on the family, and incurs a lot of legal fees and negative publicity.</p>
    
                                <p>Of course, in practice, too few families use professional management or objective appraisal techniques to ensure good performance over right and privilege.&nbsp; But the most successful family enterprises in existence over the generations realize that the human resource skills population available from non-family outsiders is far greater than within the family, and can heighten the likelihood of the achievement of long term success and continuity when working with family members.</p>
    
                                <p>So the question each family enterprise must ask at some point is, do we really have the best talent to succeed.&nbsp; And if not, are we willing to hire, reward and retain the best people?</p>
    
                                <p><strong>Decision Tree Question: Are You Ready to Hire, Reward and Retain the Best People?</strong></p>
                            </div>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.1')">Previous</a>
                                <a class="next" @click="showTile('4.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('4.3')" class="preview" @click="showTile('4.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Balancing Leadership at Home and Work">
                            </div>
                            <div class="description">
                                <strong>Balancing Leadership at Home and Work</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('4.3')" class="item-content">
                            
                            <div class="block">

                                <h1>Balancing Leadership at Home and Work</h1>
                                <div class="res-date">Published: Oct 11, 2022</div>

                                    
                                <h2>Let’s Talk Family Enterprise Podcast Episode #40</h2>
                                
                                <p><strong>Host:</strong> Ruth Steverlynck</p>
                                
                                <p><strong>Guest:</strong> Deena Chochinov</p>
                                
                                <p>Host <strong>Ruth Steverlynck</strong> sits down with <strong>Deena Chochinov</strong> to talk about her new book, <em>Homework: How to Be a Leader in the Boardroom and the Living Room</em>. Deena shares insights and tools from her work that are particularly relevant to advisors working with family enterprises.</p>
                                
                                <figure class="wp-block-audio"><audio controls="" src="https://traffic.libsyn.com/familyenterpriseadvisors/FEX_040.mp3"></audio></figure>
                                    
                                    
                                    

                            </div>


                            <div class="additional-resources">
                                <h3>Books Mentioned in this Podcast</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/balancing-leadership-at-home-and-work/How%20to%20Be%20a%20Leader%20in%20the%20Boardroom%20and%20the%20Living%20Room" target="_blank">Homework: How to Be a Leader in the Boardroom and the Living Room</a></li>
                                    <li class="link"><a href="https://www.amazon.ca/High-Conflict-Why-Get-Trapped/dp/1982128569" target="_blank">High Conflict: Why We Get Trapped and How We Get Out</a></li>
                                </ul>
                            </div>
                            
                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.2')">Previous</a>
                                <a class="next" @click="showTile('4.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('4.4')" class="preview" @click="showTile('4.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Balancing Hard and Soft Skills Development as a Next Generation">
                            </div>
                            <div class="description">
                                <strong>Balancing Hard and Soft Skills Development as a Next Generation</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('4.4')" class="item-content">
                            <h1>Balancing Hard and Soft Skills Development as a Next Generation</h1>
                            <div class="res-author">Max Fortmuller</div>
                            <div class="res-date">Published: Oct 12, 2022</div>

                            
                            <iframe src="https://player.vimeo.com/video/742359791?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                           
                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.3')">Previous</a>
                                <a class="next" @click="showTile('4.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('4.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('4.5')" class="preview" @click="showTile('4.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo115271438.jpg'" alt="How to Start a Family Covenant?">
                            </div>
                            <div class="description">
                                <strong>How to Start a Family Covenant?</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('4.5')" class="item-content">
                            <div class="block">
                                <h1>How to Start a Family Covenant?</h1>
                                <div class="res-author">Lena Jungell</div>
                                <div class="res-date">Published: Dec 23, 2014</div>  
                                
                                <p>Listen to Lena as she explains the development of a family charter. Though developing a charter proved to be challenging, as elements of the business are constantly changing, it is important in a family business to create a project that all members can be involved in.</p>

                                <iframe src="https://player.vimeo.com/video/115271438?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.4')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('5.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>






            <div v-if="step == 5">
                <h1 v-if="openedTile === 0">Transitioning Family Value</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('5.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('5.1')" class="preview" @click="showTile('5.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Have You Had The Cottage Talk?">
                            </div>
                            <div class="description">
                                <strong>Have You Had The Cottage Talk?</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('5.1')" class="item-content">
                            <div class="block">
                               <h1>Have You Had The Cottage Talk?</h1>
                               <div class="res-author">Patrick O’Connor, FEA, CFP, CLU, CHFC, TEP</div>
                               <div class="res-date">Published: Jul 2, 2019</div>
                               
                                <p>Many positive memories are made at the lake each summer as family comes together to have fun and bond at the cottage. But amidst the joviality, s’mores, and summer fun, one question doesn’t get asked:</p>
                                
                                <p>“Hey kids, when your father and I die, would you still want to keep the cottage?”</p>
                                
                                <p>Understandably, not a topic for the campfire but, tragically, it is frequently not a topic of conversation for families, period. That means, numerous cottage owning families have not had an intentional conversation around what to do with the family cottage. Ironically, this is often an attempt to avoid friction. It is not a simple or easy conversation to have. However, families who do not plan collaboratively around their family cottage are setting themselves up for some far more serious challenges and tougher conversations in the future. While estate discussions don’t feel like they align with summer fun at the lake, it’s important that you make this summer the start of these conversations.</p>
                                
                                <p>The family cottage is an asset that often comes with emotions attached. Unlike an RRSP, it’s not just an asset. It represents family values and shared family experience. It’s no wonder that you want your children to be able to have the cottage after your passing, and then pass it along to their kids. The cottage represents the essence of family legacy.</p>
                                
                                <p>As a first generation cottage owner. I can certainly vouch for the level of emotion our cottage holds for my wife and me. Our children all avow that their best childhood memories were created at the cottage. This is where we grew up together into the family we are today. Why wouldn’t our children want these experiences for their children? Of course, they do want these experiences of shared adventures and family time, but it would be a mistake to assume that our children also want the cottage.</p>
                                
                                <p>Issues with the cottage and estate are not limited to first generation cottage owners. If you are sitting in a multi-generational cottage reading this, you likely have a different perspective – and a different set of challenges on how to handle passing on the cottage. First, second, and even third cousins may be added to the mix. As time passes and families grow, the complexities multiply.</p>
                                
                                <p>Time and again we hear stories about estate settlements that have gone sideways due to disputes that centre on the family cottage. Once again, this is because it is the one asset that everyone in the family is personally connected to and most represents mom and dad and their love. Why are you not talking about this now? Probably your answer would be a variation on fear. How would you finish this sentence? “We are afraid of having an open and honest talk with our children about the sensitive issue of death and our estate because… “</p>
                                
                                <p>Don’t let fear get in the way of love! Make the time to have this courageous discussion with your family. Put the question out there: “When your mother and I die, would you want to keep the cottage?”</p>
                                
                                <p>What you hear might surprise you:</p>
                                
                                <ul><li>No, we are all living in other parts of Canada/USA now, and only make it back for one week a summer. It’s just not practical for us.</li><li>Yes, but we could never afford the taxes, maintenance, and upkeep. Without some significant financial help it wouldn’t work.</li><li>I would like to buy it if my siblings don’t see themselves wanting to use it. Is this possible? How would I pay for it?</li><li>Mom and dad, we love coming here, but frankly this is not our passion.</li><li>It would be nice, but with all of us having children and wanting to share this, we just can’t see making it work into the next generation. To avoid the potential fights, we think you should sell.</li><li>I would love it but how is that going to work with my siblings? How could we share?</li></ul>
                                
                                <p>Listen carefully. You want people’s honest thoughts and feelings. Make sure everyone has a chance to speak. Take notes, which you should share with each family member, while asking them to weigh in with any new thoughts or perspectives. Once you feel you have heard from everyone and have a clear direction to follow, let your family know how you would like to proceed. Then, seek the necessary legal help to make sure this is all well documented. Think about seeking out a professional who can help facilitate your discussion, if you feel that the topic could become too contentious.</p>
                                
                                <p>Ideally, this is a conversation that will be ongoing. Circumstances change. Family members move. They marry. They divorce. They have children. They have health events. When the cottage conversation is ongoing, it incorporates all the wonderful movement of life. The more you have these exchanges, the easier it will get and the more clarity you will create with your family.</p>
                                
                                <p>In the O’Connor family, we are still in the midst of enjoying our cottage with our adult children. We do not know what the future will bring but we have a plan in place now based on the conversations we have had as a family. We know as circumstances change, the conversations change, and our plans will change. In the meantime, we continue with the important family business of creating memories at the cottage – memories that now include the “cottage talk”.</p>
                                
                               
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('4.5')">Previous</a>
                                <a class="next" @click="showTile('5.2')">Next</a>
                            </div>
                        
                        </div>
                    </li>
                    <li :class="statusClass('5.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('5.2')" class="preview" @click="showTile('5.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo380016418.jpg'" alt="Explaining the Concept of Total Wealth">
                            </div>
                            <div class="description">
                                <strong>Explaining the Concept of Total Wealth</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('5.2')" class="item-content">

                            <div class="block">
                                <h1>Explaining the Concept of Total Wealth</h1>
                                <div class="res-author">Danielle Saputo</div>
                                <div class="res-date">Published: Jan 13, 2020</div>  
                            
                                <iframe src="https://player.vimeo.com/video/380016418?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>
                            
                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.1')">Previous</a>
                                <a class="next" @click="showTile('5.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('5.3')" class="preview" @click="showTile('5.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="The Myth of the Silver Spoon">
                            </div>
                            <div class="description">
                                <strong>The Myth of the Silver Spoon</strong>
                            </div>
                        </div>
                        <div v-if="isOpened('5.3')" class="item-content">
                            <div class="block">
                                <h1>The Myth of the Silver Spoon</h1>
                                <div class="res-date">Published: Mar 13, 2023</div>  
                                                        
                                <h2>Let’s Talk Family Enterprise Podcast Episode #45</h2>
                            
                                <p><strong>Host:</strong> Steve Legler</p>            
                                <p><strong>Guest:</strong> Kristin Keffeler</p>
                                
                                <p>Host <strong>Steve Legler</strong> speaks with <strong>Kristin Keffeler</strong> about her recent book, <em>The Myth of the Silver Spoon: Navigating Family Wealth &amp; Creating an Impactful Life.</em> They discuss how advisors to enterprising families and families of wealth can become resources to the rising generation of these families as they face challenges that are typically overlooked by society.</p>
                    
                                <p>If you enjoy this episode and want to hear more from Kristin, don’t miss out on her presentation at <a href="https://events.familyenterprise.ca/family-business-symposium-2023/" target="_blank" rel="noreferrer noopener">Symposium 2023</a> in Ottawa, May 29 – 31.</p>
                                
                                <figure class="wp-block-audio"><audio controls="" src="https://traffic.libsyn.com/familyenterpriseadvisors/FEX_045.mp3"></audio></figure>
                                                                
                            </div>

                            <div class="additional-resources">
                                <h3>Resources Mentioned in this Podcast</h3>
                                <ul>
                                    <li class="link"><a href="https://www.amazon.ca/Myth-Silver-Spoon-Navigating-Impactful/dp/1119909708" target="_blank" rel="noreferrer noopener">The Myth of the Silver Spoon: Navigating Family Wealth and Creating an Impactful Life</a></li>
                                    <li class="link"><a href="https://www.amazon.ca/Good-Inside-Guide-Becoming-Parent/dp/0063159481/ref=tmm_hrd_swatch_0?_encoding=UTF8&amp;qid=1676307506&amp;sr=8-1" target="_blank" rel="noreferrer noopener">Good Inside: A Guide to Becoming the Parent You Want to Be</a></li>
                                </ul>
                            </div>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.2')">Previous</a>
                                <a class="next" @click="showTile('5.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('5.4')" class="preview" @click="showTile('5.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo167326717.png'" alt="It’s Never Too Early To Begin Teaching Children About Finance">
                            </div>
                            <div class="description">
                                <strong>It’s Never Too Early To Begin Teaching Children About Finance</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('5.4')" class="item-content">
                            
                            <div class="block">
                                <h1>It’s Never Too Early To Begin Teaching Children About Finance</h1>
                                <div class="res-author">Patricia Saputo</div>
                                <div class="res-date">Published: Jun 9, 2016</div>  

                                <p>Patricia Saputo talks about her strategy for teaching her children about finance at an early age.</p>
                            
                                <iframe src="https://player.vimeo.com/video/167445637?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>
                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.3')">Previous</a>
                                <a class="next" @click="showTile('5.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('5.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.5')" class="preview" @click="showTile('5.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Determine the level of emotionnal ownership that exists - defining 'familyness'">
                            </div>
                            <div class="description">
                                <strong>Determine the level of emotionnal ownership that exists - defining 'familyness'</strong> <!--Did you know that the degree of emotional ownership has a major impact on family business succession? Take some time ot reflect and work on how this looks in your family -->
                            </div>
                        </div>
                        <div v-if="isOpened('5.5')" class="item-content">
                            
                            <h1>Determine the level of emotionnal ownership that exists - defining 'familyness'</h1>

                            <iframe :src="baseurl + 'assets/pdf/family/Perspectives-on-Responsible-Ownership-AU.pdf'" class="pdf"></iframe>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.4')">Previous</a>
                                <a class="next hide"></a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>


            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 5 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->


        </div>
    </div>
  </div>
</template>

<script>

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
  name: "camp2-path1",
  components: {
    
  },
  data() {
    return {
      tile: 1,
      openedTile: 0,
      completedTiles: (getCookie("completedTiles1") ? JSON.parse(getCookie("completedTiles1")) : []),
      path: 1,
      progress1: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      progress5: 0,
    };
  },
  mounted() {},
  props: ["vimeoPause","vimeoPlay","vimeoGoTo","voidPath","step"],
  computed: { },
  methods: {

    statusClass(t) {
        let c = '';
        
        if (this.isCompleted(t)) {
            c = c + ' done ';
        }
        
        if (this.activeTile(t)) {
            c = c + ' active ';
        }

        return c;
    }, 

    getProgress(s) {
        let p = 0;

        switch (s) {
            case 1:
                if (this.completedTiles.includes('1.1')) { p += 17; }
                if (this.completedTiles.includes('1.2')) { p += 17; }
                if (this.completedTiles.includes('1.3')) { p += 17; }
                if (this.completedTiles.includes('1.4')) { p += 17; }
                if (this.completedTiles.includes('1.5')) { p += 17; }
                if (this.completedTiles.includes('1.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress1 = p;
                break;

            case 2:
                if (this.completedTiles.includes('2.1')) { p += 17; }
                if (this.completedTiles.includes('2.2')) { p += 17; }
                if (this.completedTiles.includes('2.3')) { p += 17; }
                if (this.completedTiles.includes('2.4')) { p += 17; }
                if (this.completedTiles.includes('2.5')) { p += 17; }
                if (this.completedTiles.includes('2.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress2 = p;
                break;

            case 3:
                if (this.completedTiles.includes('3.1')) { p += 20; }
                if (this.completedTiles.includes('3.2')) { p += 20; }
                if (this.completedTiles.includes('3.3')) { p += 20; }
                if (this.completedTiles.includes('3.4')) { p += 20; }
                if (this.completedTiles.includes('3.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress3 = p;
                break;

            case 4:
                if (this.completedTiles.includes('4.1')) { p += 20; }
                if (this.completedTiles.includes('4.2')) { p += 20; }
                if (this.completedTiles.includes('4.3')) { p += 20; }
                if (this.completedTiles.includes('4.4')) { p += 20; }
                if (this.completedTiles.includes('4.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress4 = p;
                break;

            case 5:
                if (this.completedTiles.includes('5.1')) { p += 20; }
                if (this.completedTiles.includes('5.2')) { p += 20; }
                if (this.completedTiles.includes('5.3')) { p += 20; }
                if (this.completedTiles.includes('5.4')) { p += 20; }
                if (this.completedTiles.includes('5.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress5 = p;
                break;
        }

        return '';
    },

    goto(s) {
        this.step = s;
        this.vimeoGoTo(2, 1, s);
    },

    nextStep() {
        this.step = this.step + 1;
        this.vimeoGoTo(2, 1, this.step);
    },

    previousStep() {
        this.step = this.step - 1;
        this.vimeoGoTo(2, 1, this.step);
    },
    

    activeTile(t) {
        if (this.tile == t) {
            return true;
        }
        return false;
    },

    showTile(t) {
        
        if (this.openedTile) {
            this.closeTile()
        }

        this.tile = t;
        this.openedTile = t;
    },

    closeTile() {
        this.completed(this.openedTile);
        this.openedTile = 0;
        this.tile = 0;
    },

    isOpened(t) {
        if (this.openedTile == t) {
            return true;
        }
        return false;
    },

    completed(t) {

        if (!this.completedTiles.includes(t)) {
            this.completedTiles.push(t);
        }

       setCookie("completedTiles1", JSON.stringify(this.completedTiles));
       
        for (var i = 1; i < 6; i++) {
            this.getProgress(i);
        }

    },

    isCompleted(t) {    
        if (this.completedTiles.includes(t)) {
            return true;
        }
        return false;
    }
  }
};
</script>

<style scoped>


</style>
